const testCoverLetterBarcode = "9000000100000001";
export const testCoverLetterVoterNumber = "NC-0-000-001";
export function isCoverLetterBarcode(input: string){
    return input.length == 26;
  }

export function isTestVoterCardWithPrefixOrSuffixBarcode(input: string){
    return (input.split('').some(x => x < '0' || x > '9' )) && 
        input.includes(testCoverLetterBarcode);
}

export function isVoterCardBarcode(input: string){
    return input.length == 16;
}

export function isTestVoterCardBarcode(input: string){
    return input.startsWith("9") && input.length === 16
        && convertBarcodeToVoterNumber(input) === testCoverLetterVoterNumber;
}

export function convertBarcodeToVoterNumber(input: string){
    if(input.startsWith("9")){
        return convertCoverLetterBarcode("NC", input);
    }

    var type = parseInt(input.charAt(8));
    switch(type)
    {
        case 0:
            return convertCoverLetterBarcode("FV", input);
        case 1:
            return convertCoverLetterBarcode("KR", input);
        case 2:
            return convertCoverLetterBarcode("EV", input);
        case 3:
            return convertCoverLetterBarcode("FA", input);
        default:
            return ""
    }
}


export function tryConvertCoverLetterBarcodeToVoterNumber(scanned: string): string | undefined{
    if(isCoverLetterBarcode(scanned)){
      return convertBarcodeToVoterNumber(scanned);
    }

    return undefined;
}

export function convertCoverLetterBarcode(electionType: string, barcode: string, onlyVoterNumber: boolean = false)
{
    let voterNumber = onlyVoterNumber ? barcode : barcode.slice(9,16);
    return electionType + "-" + voterNumber.slice(0,1) + "-" + voterNumber.slice(1,4)+ "-" + voterNumber.slice(4,7)
}

export function getDateFromCoverLetterBarcode(input: string)
{
    var date = input.slice(16,22)
    return date.slice(0,2) + "-" + date.slice(2,4) + "-20" + date.slice(4,6);
}

export function getTimeFromCoverLetterBarcode(input: string)
{
    var time = input.slice(22)
    return time.slice(0, 2) + ":" + time.slice(2,4);

}

export function isCredentialBarcode(input: string){
    let verifyLength = input.length == 22;
    let verifyUsernameLetters = /^[a-z]+$/i.test(input.slice(0,4));
    let verifyUsernameNumbers = /^\d+$/.test(input.slice(4,6));

    return verifyLength && verifyUsernameLetters && verifyUsernameNumbers;
  }

export function convertBarcodeToCredentials(barcode: string){
    let username = barcode.slice(0,6);
    let password = barcode.slice(6);
    return {username: username, password: password};
}

export function getElectionIdFromCoverLetterBarcode(input: string)
{
    return input.slice(0, 8);
}